function initConfetti() {
  // Wait for confetti library to be available
  if (typeof confetti === 'undefined') {
    setTimeout(initConfetti, 50);
    return;
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  
  // Find all elements with data-confetti attribute
  const confettiElements = document.querySelectorAll('[data-confetti]');
  
  if (confettiElements.length === 0) {
    // Retry if elements haven't loaded yet
    setTimeout(initConfetti, 100);
    return;
  }
  
  // Check each element and trigger confetti if URL param matches
  confettiElements.forEach(element => {
    const paramName = element.getAttribute('data-confetti');
    if (urlParams.has(paramName)) {
      // Wait a bit for the element to render
      setTimeout(() => {
        const rect = element.getBoundingClientRect();
        const x = (rect.left + rect.width / 2) / window.innerWidth;
        const y = (rect.top + rect.height / 2) / window.innerHeight;
        
        // Trigger confetti from the center of the element
        confetti({
          particleCount: 150,
          spread: 100,
          origin: { x, y },
          colors: ['#C1E8B7', '#FFFAED', '#3D3D3A', '#E9E8D5', '#FFAC64', '#84C4CA', '#478CE1']
        });
      }, 50);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initConfetti);
} else {
  initConfetti();
}

